namespace appn.views.repository.installs {

    let _dataTable: any = null;
    let _filter = appn.emptyString;

    export function init(): void {
        createDataTable();
        addEvents();
    }

    function addEvents() {
        $('.folderchange').click(function(e) {
            e.preventDefault();

            $('.folder').removeClass('active');
            $(this).parents('.folder').addClass('active');

            // Get Id and redraw datatable
            _filter = $(this)[0].id;
            _dataTable.fnDraw(false);
        });
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            sAjaxSource: 'DataTable',
            fnServerData: function(data: any) {
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')),
                    appn.dataTable.getStateOrDefault('sCustom_1', _filter));
            },
            aoColumns: [
                { bSortable: true, sWidth: '60%' },
                { bSortable: true, sWidth: '17%' },
                { bSortable: true, sWidth: '20%' }
            ],
            fnInitComplete: function() {
                appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                appn.dataTable.addSearchPlaceholder(T('Filter results where the Installed Repository Items <b>Name or Type</b> contains a keyword typed in here.'));

                appn.saveMeState.init(function() {
                    _dataTable.fnDraw(false);
                },
                    function() {
                        _dataTable.fnDraw(false);
                    }, '.dataTables_filter');
            }
        });
    }
}
